import { __assign } from 'tslib';
import { NotificationDelay, NotificationStyle } from './notifications.constants.js';
import { Notification } from './notification.js';
import Vue from 'vue';

var NotificationService = /** @class */ (function () {
    function NotificationService() {
        this.lastMessageId = 0;
        Vue.set(this, 'notifications', {});
    }
    /**
     * Opens a notification using the element provided
     * @param body
     *  - If body is a string then a default 'magic-notification' element
     *    will be used with it's inner html set to the body
     *
     *  - If body is an element then that element will be rendered
     * @param options Options for this notification
     */
    NotificationService.prototype.show = function (body, options) {
        var _this = this;
        var id = ++this.lastMessageId + '';
        options = options || {};
        options.closeDelay = options.closeDelay || NotificationDelay.DEFAULT;
        options.dismissible =
            typeof options.dismissible === 'boolean'
                ? options.dismissible
                : true;
        options.hideCloseIcon =
            typeof options.hideCloseIcon === 'boolean'
                ? options.hideCloseIcon
                : false;
        var notification = new Notification(body, options, id);
        Vue.set(this.notifications, id, notification);
        if (options.closeDelay !== NotificationDelay.PERMANENT) {
            setTimeout(function () {
                _this.close(notification);
            }, options.closeDelay);
        }
        return notification;
    };
    NotificationService.prototype.error = function (body, options) {
        return this.show(body, __assign(__assign({}, options), { style: NotificationStyle.ERROR }));
    };
    NotificationService.prototype.success = function (body, options) {
        return this.show(body, __assign(__assign({}, options), { style: NotificationStyle.SUCCESS }));
    };
    /**
     * Closes the notification with the given id. Does nothing if the id does
     * not exist
     * @param id id of the notification to close
     */
    NotificationService.prototype.close = function (notification) {
        if (notification.id in this.notifications) {
            var currNotification = this.notifications[notification.id];
            Vue.delete(this.notifications, notification.id);
            if (currNotification.onClose) {
                currNotification.onClose();
            }
        }
    };
    /**
     * Closes all open notifications.
     */
    NotificationService.prototype.closeAllNotifications = function () {
        var _this = this;
        Object.values(this.notifications).forEach(function (notification) {
            return _this.close(notification);
        });
    };
    return NotificationService;
}());
var notificationService = new NotificationService();

export { NotificationService, notificationService };
